import React, { useState, useEffect } from 'react'

import { shape, string, bool, func, arrayOf } from 'prop-types'

let LicenseDropdown

function LicenseDropdownLoader({
  licenseConfig,
  onClose: handleClose,
  isActive,
  showAiContactNote = false,
  locale = 'en',
  onLicenseClick: handleLicenseClick,
}) {
  const [isLicenseDropdownLoaded, setIsLicenseDropdownLoaded] = useState(false)

  useEffect(() => {
    if (isActive && !LicenseDropdown && !isLicenseDropdownLoaded) {
      importLicenseDropdown()
    }
  }, [isActive, isLicenseDropdownLoaded])

  function importLicenseDropdown() {
    import('Pods/LazyLoaded/LicenseDropdown/LicenseDropdown')
      .then((module) => {
        LicenseDropdown = module.default
        setIsLicenseDropdownLoaded(true)
      })
      .catch((error) => {
        console.error('Failed to load LicenseDropdown:', error)
      })
  }

  if (!isActive || !isLicenseDropdownLoaded || !LicenseDropdown) {
    return null
  }

  return (
    <LicenseDropdown
      licenseConfig={licenseConfig}
      onClose={handleClose}
      showAiContactNote={showAiContactNote}
      locale={locale}
      onLicenseClick={handleLicenseClick}
    />
  )
}

LicenseDropdownLoader.propTypes = {
  licenseConfig: shape({
    title: string.isRequired,
    allowAi: bool.isRequired,
    features: arrayOf(shape({
      description: string.isRequired,
      isActive: bool.isRequired,
      title: string.isRequired,
      link: string,
    })).isRequired,
  }).isRequired,
  onClose: func.isRequired,
  isActive: bool.isRequired,
  showAiContactNote: bool,
  locale: string,
  onLicenseClick: func.isRequired,
}

export default LicenseDropdownLoader
